<template>
  <div>
    <div class="register_box">
      <div class="register">
        <div class="login_title">机构填报信息承诺书</div>
        <div class="login_input" v-html="info.value"></div>
        <div class="ts_tiem_left">
          <el-radio
            @click.native.prevent="clickitem()"
            v-model="radio"
            :label="true"
            ><span style="display: none">1</span></el-radio
          ><span> 我已阅读并承诺 </span>
        </div>
        <div class="login_button_box" @click="signIn">
          <div class="login_button_text">确定，进入系统</div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  data() {
    return {
      radio: false,
      info: {},
    };
  },
  mounted() {
    this.getinfo();
  },
  methods: {
    getinfo() {
      let that = this;
      let data = {};
      that.$http.post("institution/common/getCommit", data).then((res) => {
        if (res.code == 1) {
          that.info = res.data;
        }
      });
    },
    //同意协议
    clickitem(e) {
      this.radio = !this.radio;
    },

    //注册
    signIn() {
      let that = this;
      if (that.radio == false) {
        this.$message.error("请先勾选协议！");
        return;
      }
      this.$router.push(this.$route.query.redirect || "/");
    },
  },
};
</script>
  <style>
.xy {
  width: 50%;
  height: 85%;
  overflow: auto !important;
}

.zu .el-message-box {
  width: 300px !important;
  /* height: 298px; */
}
.zu .el-message-box__title {
  text-align: center;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #29469a;
}
.zu .el-message-box__message {
  margin: 59px auto;
  width: 288px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  text-align: center;
}
.zu .el-message-box__btns .el-button {
  width: 340px;
  height: 40px;
  background: #29469a;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
}
/* 滚动条样式,隐藏 */
.xy::-webkit-scrollbar {
  width: 0px;
}

.xy::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0);
}

.xy .el-button--small {
  padding: 12px 28px;
  font-size: 15px;
  border-radius: 3px;
}
</style>
  <style scoped>
.register_box {
  padding: 0.7875rem 0 1.0375rem;
}

.register {
  width: 9.5rem;
  background: #ffffff;
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.15);
  border-radius: 6px 6px 0px 6px;
  margin: auto;
  padding: 0.4875rem 1rem 0.375rem;
  box-sizing: border-box;
}

.login_title {
  font-size: 0.375rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  text-align: center;
}

.login_input {
  margin: 1rem 0 0.4875rem;
  font-size: 0.25rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 0.3rem;
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-form-item {
  border: 1px solid #e6e6e6;
  background: #fafcfd;
}

::v-deep .el-form-item__label {
  position: relative;
  font-size: 0.2rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333 !important;
}

::v-deep .el-form-item__label::after {
  position: absolute;
  content: "";
  top: 11px;
  right: 0px;
  width: 1px;
  height: 19px;
  background: #999999;
  opacity: 0.32;
}

::v-deep .el-input__inner {
  border: none;
  background: #fafcfd;
}

::v-deep .el-input .el-input__inner::placeholder {
  color: #999999 !important;
}

.code_box {
  width: 150px;
  background: #1954a4;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.175rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

::v-deep .el-form-item__content {
  display: flex;
  align-items: center;
}

::v-deep .el-radio__inner {
  border-radius: 30%;
}

::v-deep .el-radio {
  margin-right: 0px;
}

.th_text {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ts_tiem_left {
  font-size: 0.175rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.ts_tiem {
  font-size: 0.175rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.login_button_box {
  width: 7.5rem;
  height: 0.55rem;
  background: rgba(25, 84, 164, 1);
  text-align: center;
  line-height: 0.55rem;
  margin-top: 1.3rem;
  cursor: pointer;
}

.login_button_box:hover {
  /* background: #0939ca; */
}

.login_button_text {
  font-size: 0.225rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
</style>
    